export default "__VITE_ASSET__BezN7ZM1__"